import Headroom from 'headroom.js'

const siteHeader = document.querySelector('.siteHeader__wrapper')

const headroom = new Headroom(siteHeader, {
    offset: siteHeader.getBoundingClientRect().height,
    tolerance: 5,
    classes: {
        // when element is initialised
        initial: 'siteHeader__wrapper',
        // when scrolling up
        pinned: 'siteHeader--pinned',
        // when scrolling down
        unpinned: 'siteHeader--unpinned',
        // when above offset
        top: 'siteHeader--top',
        // when below offset
        notTop: 'siteHeader--not-top',
        // when at bottom of scroll area
        bottom: 'siteHeader--bottom',
        // when not at bottom of scroll area
        notBottom: 'siteHeader--not-bottom',
        // when frozen method has been called
        frozen: 'siteHeader--frozen'
    }
})

headroom.init()
